
export const customerReviews = [
  {
    id: 1,
    bookingId: 'VE-2025-4821',
    name: 'Philippe Durand',
    date: '2025-01-19',
    route: 'Genève → Courchevel',
    rating: 5,
    comment: 'Transfert parfait depuis Genève vers Courchevel. Le chauffeur Alexandre était ponctuel, professionnel et très courtois. La Mercedes Classe E était impeccable, avec bouteilles d\'eau et chargeurs à disposition. Conduite sûre malgré la neige. Je recommande vivement !',
    photo: 'https://public.readdy.ai/ai/img_res/52b7559b4438ac92d1fbba8782468b8f.jpg',
    chauffeur: 'Alexandre M.',
    vehicle: 'Mercedes Classe E',
  },
  {
    id: 2,
    bookingId: 'VE-2025-5102',
    name: 'Sophie Martin',
    date: '2025-01-26',
    route: 'Moûtiers → Méribel',
    rating: 5,
    comment: 'Service exceptionnel pour notre groupe de 5 personnes. Le Van Mercedes était spacieux et confortable, tous nos bagages et skis ont été parfaitement rangés. Thomas connaît les routes de montagne comme sa poche. Arrivée à Méribel en toute sérénité.',
    photo: 'https://readdy.ai/api/search-image?query=luxury%20black%20mercedes%20van%20parked%20at%20meribel%20ski%20resort%20entrance%20snowy%20mountains%20background%20winter%20sunshine%20professional%20transport%20service%20photography&width=600&height=400&seq=review-photo-002&orientation=landscape',
    chauffeur: 'Thomas R.',
    vehicle: 'Mercedes Van',
  },
  {
    id: 3,
    bookingId: 'VE-2025-5387',
    name: 'Laurent Mercier',
    date: '2025-02-09',
    route: 'Lyon → Val Thorens',
    rating: 5,
    comment: 'Excellent transfert depuis Lyon Saint-Exupéry. Alexandre nous attendait à la sortie avec une pancarte. Le trajet jusqu\'à Val Thorens s\'est déroulé dans un confort absolu. Véhicule chauffé, musique douce, et des conseils sur les meilleures pistes. Top !',
    photo: 'https://readdy.ai/api/search-image?query=scenic%20alpine%20road%20winding%20through%20snowy%20french%20alps%20mountains%20val%20thorens%20direction%20winter%20landscape%20beautiful%20sunset%20golden%20hour%20professional%20photography&width=600&height=400&seq=review-photo-003&orientation=landscape',
    chauffeur: 'Alexandre M.',
    vehicle: 'Mercedes Classe E',
  },
  {
    id: 4,
    bookingId: 'VE-2025-5690',
    name: 'Isabelle Rousseau',
    date: '2025-02-23',
    route: 'Chambéry → Les Arcs',
    rating: 5,
    comment: 'Nous étions 6 avec beaucoup de bagages et d\'équipement de ski. Thomas a tout géré avec une efficacité remarquable. Le Van est vraiment luxueux avec ses sièges en cuir. Le trajet vers Les Arcs était magnifique et très confortable. Merci !',
    photo: 'https://readdy.ai/api/search-image?query=luxury%20mercedes%20van%20interior%20leather%20seats%20comfortable%20passengers%20winter%20mountain%20transfer%20professional%20chauffeur%20service%20warm%20lighting%20elegant&width=600&height=400&seq=review-photo-004&orientation=landscape',
    chauffeur: 'Thomas R.',
    vehicle: 'Mercedes Van',
  },
  {
    id: 5,
    bookingId: 'VE-2024-3201',
    name: 'Marc Fontaine',
    date: '2024-12-21',
    route: 'Genève → Megève',
    rating: 5,
    comment: 'Service haut de gamme pour notre séjour à Megève. Le chauffeur était d\'une ponctualité exemplaire et la Mercedes Classe E d\'une propreté irréprochable. Le trajet depuis Genève fut un vrai plaisir avec les paysages enneigés. Nous referons appel à Voyage Elite.',
    photo: 'https://readdy.ai/api/search-image?query=charming%20megeve%20village%20covered%20in%20snow%20french%20alps%20luxury%20ski%20resort%20christmas%20lights%20evening%20atmosphere%20cozy%20winter%20wonderland%20professional%20photography&width=600&height=400&seq=review-photo-005&orientation=landscape',
    chauffeur: 'Alexandre M.',
    vehicle: 'Mercedes Classe E',
  },
  {
    id: 6,
    bookingId: '',
    name: 'Caroline Blanc',
    date: '2024-12-28',
    route: 'Genève → Verbier',
    rating: 5,
    comment: 'Transfert impeccable vers Verbier en Suisse. Le passage de la frontière s\'est fait sans aucun souci. Chauffeur très professionnel qui connaît parfaitement les routes alpines. Véhicule luxueux et très propre. Une expérience premium du début à la fin.',
    photo: 'https://readdy.ai/api/search-image?query=verbier%20swiss%20ski%20resort%20panoramic%20view%20snowy%20mountains%20luxury%20chalets%20winter%20sunshine%20blue%20sky%20alpine%20landscape%20professional%20photography&width=600&height=400&seq=review-photo-006&orientation=landscape',
    chauffeur: 'Alexandre M.',
    vehicle: 'Mercedes Classe E',
  },
];
